<section class="compare-cards-section" *ngIf="compareCardsContent && compareCardsActive">
    <div class="box">
        <h2 id="title" class="sub-heading" [innerHTML]="compareCardsContent?.heading | safeHtml">
        </h2>
        <div class="table-container">
            <table class="image-table" aria-describedby="title">
                <caption class="sr-only">Cards Comparision</caption>
                <thead>
                    <tr>
                        <th class="desktop-only" aria-hidden="true" aria-colspan="2" role="presentation"></th>
                        <th *ngFor="let cardData of compareCardsContent?.cardImages">
                           <app-card-art
                           [id]="'pdp-comparecards-cardart-'+ cardData?.pid"
                           [pid]="cardData?.pid"
                           [defaultSize]="cardImageSize"
                           [linkHref]="cardData?.crsApplyNowURL"
                           [linkTarget]="hrefTarget"
                           [enablePdpLink]="false"
                           (click)="applyNow('cardArtCompare'+cardData?.pid)"
                            ></app-card-art>
                            <ng-container *ngIf="cardData?.crsApplyNowURL; else cardTitle">
                                <span *ngIf="cardData?.cardTitle" calss="card-title" [innerHtml]="cardData?.cardTitle" role="presentation" aria-hidden="true"></span>
                            </ng-container>
                            <ng-template #cardTitle>
                                <span *ngIf="cardData?.cardTitle" calss="card-title" [innerHtml]="cardData?.cardTitle" role="presentation" aria-hidden="true"></span>
                                <span *ngIf="cardData?.cardTitle" class="sr-only" [innerHtml]="cardData?.cardTitle | adaFriendlyName: 'ariaLabel'"></span>
                            </ng-template>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="compareCardsContent?.cardImages[0]?.crsApplyNowURL">
                        <td class="desktop-only" aria-hidden="true" aria-colspan="2"  role="presentation"></td>
                        <td *ngFor="let cardData of compareCardsContent?.cardImages">
                            <ui-card-button *ngIf="cardData?.crsApplyNowURL" [btnName]="cardDetails?.cardApplyNowBtnText" (click)="applyNow('applyNowCompare'+cardData?.pid)"
                            [btnLink]="cardData?.crsApplyNowURL" [tagText]="cardDetails?.cardApplyNowBtnText.toLowerCase()+' top'"
                            [cardName]="cardData?.cardTitle" [size]="0"  [hrefTarget]="hrefTarget">
                            </ui-card-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <ng-container *ngIf="isTabletAndBeyondSize$ | async">
                <table class="content-table desktop-only" *ngFor="let cardData of compareCardsContent?.tables" role="table">
                    <caption class="sr-only">Cards Comparision</caption>
                    <thead *ngIf="cardData?.tableHeading">
                        <tr>
                            <th colspan="3">
                                <h3 [innerHTML]="cardData?.tableHeading | safeHtml" aria-hidden="true"></h3>
                                <span aria-level="3" role="heading" class="sr-only" [innerHTML]="cardData?.tableHeading | adaFriendlyName: 'ariaLabel'"></span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of cardData.rows">
                            <td [innerHTML]="row.content | safeHtml"></td>
                            <td *ngFor="let isApplicable of row.isApplicable;let i=index;">
                                <span  class="bg-chk-img">
                                    <img [cache]="isApplicable ? compareCardsContent?.iconPathApplicableYes : compareCardsContent?.iconPathApplicableNo" [lazyload]="isApplicable ? compareCardsContent?.iconPathApplicableYes : compareCardsContent?.iconPathApplicableNo" role="presentation" aria-hidden="true" alt="{{compareCardsContent?.cardImages[i]?.cardTitle}}">
                                <span class="sr-only" [innerHTML]="isApplicable ? (compareCardsContent?.cardImages[i]?.cardTitle | adaFriendlyName: 'ariaLabel') + compareCardsContent?.adaTextYes : (compareCardsContent?.cardImages[i]?.cardTitle | adaFriendlyName: 'ariaLabel') + compareCardsContent?.adaTextNo"></span>
                            </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
            <ng-container *ngIf="isMobileScreenSize$ | async">
                <table class="content-table-mobile" *ngFor="let cardData of compareCardsContent?.tables" role="table">
                    <caption class="sr-only">Cards Comparision</caption>
                    <thead *ngIf="cardData?.tableHeading">
                        <tr>
                            <th colspan="2">
                                <h3 [innerHTML]="cardData?.tableHeading | safeHtml" aria-hidden="true"></h3>
                                <span aria-level="3" role="heading" class="sr-only" [innerHTML]="cardData?.tableHeading | adaFriendlyName: 'ariaLabel'"></span>
                            </th>
                        </tr>
                    </thead>
                    <ng-container *ngFor="let row of cardData.rows;let i=index;">
                        <tbody>
                            <tr *ngIf="row?.content">
                                <td colspan="2">
                                    <span class="content-center" [innerHTML]="row?.content | safeHtml"></span>
                                </td>
                            </tr>
                            <tr>
                                <td *ngFor="let isApplicable of row.isApplicable;let i=index;">
                                    <span  class="bg-chk-img">
                                        <img [cache]="isApplicable ? compareCardsContent?.iconPathApplicableYes : compareCardsContent?.iconPathApplicableNo" [lazyload]="isApplicable ? compareCardsContent?.iconPathApplicableYes : compareCardsContent?.iconPathApplicableNo" role="presentation" aria-hidden="true" alt="{{compareCardsContent?.cardImages[i]?.cardTitle}}">
                                    <span class="sr-only" [innerHTML]="isApplicable ? (compareCardsContent?.cardImages[i]?.cardTitle | adaFriendlyName: 'ariaLabel') + compareCardsContent?.adaTextYes : (compareCardsContent?.cardImages[i]?.cardTitle | adaFriendlyName: 'ariaLabel') + compareCardsContent?.adaTextNo"></span>
                                </span>
                                </td>
                            </tr>
                        </tbody>
                    </ng-container>
                </table>
            </ng-container>
        </div>
        <div role="presentation" aria-hidden="true" class="spacer"></div>
    </div>
</section>
